module.exports = __webpack_public_path__ + "img/kaminatrans-logo.4ae0cb1d.png";